export const en = {
  'siteDesign.uiScale': 'UI text size',
  'siteDesign.uiScale.hint': 'Scales the text set in the UI face: buttons, menus, labels and badges, on the site and in the sign-in pages and member area when they wear it. For a face that is narrow at its usual size.',
  'siteDesign.uiScale.normal': 'Normal',
  'siteDesign.uiScale.large': 'Large',
  'siteDesign.uiScale.larger': 'Larger',
  'siteDesign.uiScale.largest': 'Largest',
  'siteDesign.uiBold': 'Heavier UI text',
  'siteDesign.uiBold.hint': 'Buttons, menus, labels and eyebrows in the UI face are drawn heavier: bold where the face has a bold file, otherwise Latin letters get a thin outline in their own colour. Georgian letters are left as drawn.',
  'siteDesign.motion': 'Motion',
  'siteDesign.motion.hint': 'Lively: the cover arrives in sequence, sections and cards rise into view, and buttons and cards answer the pointer. Every visitor sees it unless Calmer motion is on.',
  'siteDesign.calmMotion': 'Calmer motion for visitors whose device asks for less',
  'siteDesign.calmMotion.hint': 'Off: every visitor sees the full motion, whatever their device says. On: a visitor whose device asks for reduced motion sees soft fades, colour changes on hover and press but no lifts or scales, and instant carousel moves. Films set to play on screen play for everyone.',
  'siteDesign.motion.none': 'Still',
  'siteDesign.motion.lively': 'Lively',
  'siteDesign.scrollbar': 'Scrollbars',
  'siteDesign.scrollbar.hint': "Brand: the brand colour on the page's background. Quiet: the text colour, faint. Browser: the browser's own.",
  'siteDesign.scrollbar.brand': 'Brand colour',
  'siteDesign.scrollbar.quiet': 'Quiet',
  'siteDesign.scrollbar.browser': "The browser's own",
  'siteDesign.field': 'Form fields',
  'siteDesign.field.hint': 'How inputs, selects and text areas on the site are drawn. Focus is always the brand colour.',
  'siteDesign.field.outline': 'Outlined',
  'siteDesign.field.filled': 'Filled',
  'siteDesign.field.line': 'Underlined',
};

export const ka: Record<keyof typeof en, string> = {
  'siteDesign.uiScale': 'ინტერფეისის ტექსტის ზომა',
  'siteDesign.uiScale.hint': 'ცვლის ინტერფეისის შრიფტით დაწერილი ტექსტის ზომას: ღილაკები, მენიუები, წარწერები და ბეჯები საიტზე, ასევე შესვლის გვერდებსა და წევრის სივრცეში, როცა ისინი საიტის იერს ატარებენ. შრიფტისთვის, რომელიც ჩვეულებრივ ზომაზე ვიწროა.',
  'siteDesign.uiScale.normal': 'ჩვეულებრივი',
  'siteDesign.uiScale.large': 'დიდი',
  'siteDesign.uiScale.larger': 'უფრო დიდი',
  'siteDesign.uiScale.largest': 'უდიდესი',
  'siteDesign.uiBold': 'უფრო მკვრივი ინტერფეისის ტექსტი',
  'siteDesign.uiBold.hint': 'ინტერფეისის შრიფტით დაწერილი ღილაკები, მენიუები, წარწერები და ზედწარწერები უფრო მკვრივად იხატება: თამამი ვარიანტით, თუ შრიფტს აქვს, სხვა შემთხვევაში ლათინურ ასოებს თავისივე ფერის წვრილი კონტური ემატება. ქართული ასოები უცვლელი რჩება.',
  'siteDesign.motion': 'მოძრაობა',
  'siteDesign.motion.hint': 'ცოცხალი: ყდა თანმიმდევრულად ჩნდება, სექციები და ბარათები ეკრანზე ამოდის, ღილაკები და ბარათები კურსორს პასუხობს. ყველა სტუმარი ამას ხედავს, თუ უფრო მშვიდი მოძრაობა ჩართული არ არის.',
  'siteDesign.calmMotion': 'უფრო მშვიდი მოძრაობა იმ სტუმრებისთვის, ვისი მოწყობილობაც ნაკლებს ითხოვს',
  'siteDesign.calmMotion.hint': 'გამორთული: ყველა სტუმარი სრულ მოძრაობას ხედავს, მოწყობილობის პარამეტრების მიუხედავად. ჩართული: ვისი მოწყობილობაც შემცირებულ მოძრაობას ითხოვს, ხედავს რბილ გამოჩენას, ფერის ცვლილებას გადატარებისა და დაჭერისას, მაგრამ არა აწევას ან გადიდებას, და კარუსელი მყისიერად მოძრაობს. ეკრანზე ჩასართავი ვიდეოები ყველასთვის ირთვება.',
  'siteDesign.motion.none': 'უძრავი',
  'siteDesign.motion.lively': 'ცოცხალი',
  'siteDesign.scrollbar': 'გადახვევის ზოლები',
  'siteDesign.scrollbar.hint': 'ბრენდის: ბრენდის ფერი გვერდის ფონზე. მშვიდი: ტექსტის ფერი, მკრთალად. ბრაუზერის: ბრაუზერის საკუთარი.',
  'siteDesign.scrollbar.brand': 'ბრენდის ფერი',
  'siteDesign.scrollbar.quiet': 'მშვიდი',
  'siteDesign.scrollbar.browser': 'ბრაუზერის საკუთარი',
  'siteDesign.field': 'ფორმის ველები',
  'siteDesign.field.hint': 'როგორ გამოიყურება საიტზე ველები, არჩევანის სიები და ტექსტის არეები. ფოკუსი ყოველთვის ბრენდის ფერია.',
  'siteDesign.field.outline': 'კონტურით',
  'siteDesign.field.filled': 'შევსებული',
  'siteDesign.field.line': 'ხაზგასმული',
};
